<template>
  <div class="client-bids min-vh-100">
    <div class="container-fluid client">
      <div class="clientWrap">
        <div class="row">
          <div class="col-md-12 py-4 text-left">
            <div class="d-flex justify-content-between align-items-center">
              <h1>{{ isClient ? "My" : 'Users' }} Portfolio</h1>
            </div>
          </div>
        </div>
       <div class="row" v-if="isAdmin || isRep">
          <div class="col-md-12">
              <div class="dark-filter w-100 p-1 mb-2 d-inline-block">
                <!-- <div class="d-flex justify-content-between align-items-center">
                    <h5 class="ml-3 m-0">Filters</h5>
                    <span class="btn btn-link" @click="showFilters = !showFilters">
                    <i
                      class="fa"
                      v-bind:class="[
                      showFilters ? 'fa-angle-up' : 'fa-angle-down'
                      ]"
                      ></i>
                    {{ showFilters ? 'Hide' : 'Show' }} Filters
                    </span>
                </div> -->
                <div class="row p-4" v-if="showFilters">
                    <div class="col-lg-12">
                      <form class="row">
                          <div class="col-md-6 col-lg-3">
                            <label for="filter" class="">User</label>
                             <multiselect
                                v-model="selectedClient"
                                placeholder="Select"
                                :options="clients"
                                :multiple="false"
                                label="clientFullName"
                                track-by="id"
                              ></multiselect>
                          </div>
                          
                          
                         
                          <div class="col-md-6 col-lg-3 d-flex align-items-center">
                            <!-- <button
                                @click="clearFilter()"
                                type="button"
                                class="btn btn-secondary rounded mt-4"
                                >
                            Clear
                            </button> -->
                            <button
                                @click="fetchClientPortfolio()"
                                type="button"
                                class="btn btn-primary rounded mt-4"
                                >
                            Search By User
                            </button>
                          </div>
                      </form>
                    </div>
                </div>
              </div>
          </div>
        </div>
        
        <div class="row">
          <div class="col-md-12">
            <div class="history filter-list">
              <!-- Add CUSIP -->
              <div v-if="isClient" class="mb-4">
                <div class="d-flex justify-content-end">
                  <input
                    v-model="newCusip"
                    type="text"
                    class="form-control w-25 cusip-input"
                    placeholder="Enter Cusip"
                  />
                  <button id="v-step-0" class="btn btn-outline-primary ml-2 mr-4 btn-sm" style="width: 80px; color: #fff; height: 35px;" @click="checkCusipExist()">
                    Add
                  </button>
                  <a @click="toggleImportModal" class="btn btn-primary" style="width: auto; padding-top: 7px; height: 35px; color: #fff;">
                      <i class="fas fa-file-import"></i> Import portfolio
                    </a>
                </div>
              </div>

              <!-- Table -->
              <div class="table-responsive p-0">
                <table class="table table-hover table-striped">
                  <thead>
                    <tr>
                      <th class="text-left">Cusip</th>
                      <th class="text-left">Description</th>
                      <th class="text-center">Maturity Date</th>
                      <th class="text-center">Call Date</th>
                      <th class="text-left">Coupon</th>
                      <th class="text-center">Rating </th>
                      <th class="text-left">Bond Insurer</th>
                      <th class="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="cusip in cusips" :key="cusip.id">
                      <td class="cusip-color-badge text-left">{{ cusip.cusip }}</td>
                      <td class="text-left">{{ cusip.description }}</td>
                      <td class="text-center">{{ cusip.maturityDate }}</td>
                      <td class="text-center">{{ cusip.callDate }}</td>
                      <td class="text-left">{{ cusip.coupon | percent(3) }} </td>
                      <td class="text-center">{{ cusip.ratingSP }}</td>
                      <td class="text-left">{{ cusip.bondInsurerAbbr }}</td>
                      <td class="text-center">
                        <button
                          class="btn btn-danger btn-sm"
                          @click="removeCusip(cusip.id)"
                        >
                          <i class="fas fa-trash"></i> 
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ClientImportCusip v-if="showImportModal" @close="toggleImportModal" />
    <v-tour name="PortfolioTour" :steps="steps" :options="myOptions" :callbacks="myCallbacks"></v-tour>
  </div>
</template>
<script>
import authService from '@/authService'
import config from '@/config'
import ClientImportCusip from './ClientImportCusip.vue'
export default {
  name: 'ClientPortFolio',
  components: {
    ClientImportCusip
  },
  data () {
    return {
      cusips: [],
      showImportModal: false,
      newCusip: '',
      isClient: false,
      isAdmin: false,
      showFilters: false,
      clients: [],
      selectedClient: null,
      isRep: false,

      steps: [
          {
            target: '#v-step-0',  // We're using document.querySelector() under the hood
            content: ` You can monitor bonds you own or wish to track by adding CUSIPs directly using this option. Once added, the security will appear in the tracking list.`,
            params: {
              enableScrolling: false
            }
          },
        ],
        myCallbacks: {
          onFinish: () => {
            localStorage.setItem('client_tour_completed_portfolio', 'true');
          },
          onSkip: () => {
            localStorage.setItem('client_tour_completed_portfolio', 'true');
          }
        },
        myOptions: {
          enableScrolling: false,
          labels: {
            buttonSkip: 'Skip tour',
            buttonPrevious: 'Previous',
            buttonNext: 'Next',
            buttonStop: 'Finish'
          }
        },


    }
  },
  methods: {
    clearFilter() {
      this.selectedClient = null;
      this.fetchClientPortfolio();
    },
     getClients () {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      let url = '';
      if (this.isRep && !this.isAdmin) {
        url =
          config.baseUrlAutoBidder +
          '/user/client-list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&clientRepId=' +
          authService.getUser().id
      } else {
        url =
          config.baseUrlBidSide +
          '/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=Drl-Client'
      }
      this.$http
        .get(url, auth)
        .then(result => {
          this.clients = result.data.content.map(item => {
            return {
              ...item,
              clientFullName: item.firstName + ' ' + item.lastName
            }
          })
        })
        .catch(e => {
          console.log(e)
        })
    },
    toggleImportModal() {
      this.showImportModal = !this.showImportModal;
      if(!this.showImportModal){
          this.fetchClientPortfolio();
      }
    },
    fetchClientPortfolio () {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }

      let urserId = this.isAdmin ? '' : authService.getUser().id;
      if((this.isAdmin || this.isRep)  && this.selectedClient){
          urserId = this.selectedClient.id;
      }


      this.$http
        .get(
          config.baseUrlAutoBidder +
            `/offering-feed/client-cusip?userId=` +
            urserId,
          auth
        )
        .then(response => {
          // Handle successful response
          console.log('Client Portfolio Data:', response.data)
          this.cusips = response.data
        })
        .catch(error => {
          // Handle error
          console.error('Error fetching client portfolio data:', error)
        })
    },
    addCusip () {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }

      const payload = {
        userId: authService.getUser().id,
        cusips: [this.newCusip]
      }

      this.$http
        .post(
          config.baseUrlAutoBidder + `/offering-feed/client-cusip`,
          payload,
          auth
        )
        .then(response => {
          console.log('Cusip added successfully:', response.data)
          this.newCusip = ''
          this.fetchClientPortfolio()
        })
        .catch(error => {
          console.error('Error adding cusip:', error)
        })
    },
     checkCusipExist() {
        if (!this.newCusip) {
            this.$alert('Please enter a Cusip' ,'', 'error')
            return
         }
       if(this.newCusip.length != 9){
            this.$alert("Enter 9 digit characters long CUSIP","","error");
            return
        }
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide +
            "/cusip/isExist?cusip=" + this.newCusip.trim(),
            auth
            )
              .then(response => {
                   if(response.data === "NOTEXISTS"){
                        this.$alert("CUSIP does not exist.","","error");
                        this.newCusip = '';
                        return;
                    }else{
                        this.addCusip();

                    }
              })

           
        },
    removeCusip (cusipId) {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }

      this.$http
        .put(
          config.baseUrlAutoBidder + `/offering-feed/client-cusip`,
          [cusipId],
          auth
        )
        .then(response => {
          console.log('Cusip removed successfully:', response.data)
          this.fetchClientPortfolio()
        })
        .catch(error => {
          console.error('Error removing cusip:', error)
        })
    }
  },
  created () {
     this.$cognitoAuth.getUserGroup((err, role) => {
      if (err) {
        console.log('accessToken is not found', err)
      } else {
        this.tenantName = role[0].split('-')[0]
        var roleArray = role.map(item => {
          return item.split('-')[1]
        })
        roleArray.includes('Rep') ? (this.isRep = true) : (this.isRep = false)
        roleArray.includes('Admin')
          ? (this.isAdmin = true)
          : (this.isAdmin = false)
        roleArray.includes('Client')
          ? (this.isClient = true)
          : (this.isClient = false)
          if(this.isAdmin || this.isRep){
            this.showFilters = true;
            this.getClients()
          }
          if (this.isClient) {
            this.fetchClientPortfolio()
          }
      }
    })
      setTimeout(() => {
            if(!localStorage.getItem('client_tour_completed_portfolio') && this.isClient){
               this.$tours['PortfolioTour'].start()
            }
    }, 1000);
  }
}
</script>
<style scoped>
.client-portfolio {
  padding: 20px;
}

.cusip-input {
  background: linear-gradient(180deg, #14162b, #0f1123);
  border: 1px solid #2a2f55;
  color: #e5e7eb;
  border-radius: 10px;
  padding: 10px 14px;
  min-width: 260px;
}

.cusip-input::placeholder {
  color: #9aa0c3;
}

.cusip-input:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.25);
  background: #0f1123;
}

.cusip-color-badge {
    color: #ffffff;
    font-size: 12px;
    font-weight: 500;
    text-transform: capitalize;
}

</style>
